import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycabserviceinpune() {



  const cardData =
  {
    keyword: 'Monthly Cab Services in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Monthly Cab Services in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited offers reliable and affordable Monthly Cab Services in Pune for businesses, employees, and executives who need consistent and comfortable travel. With a premium fleet of sedans, SUVs, and luxury vehicles, we provide hassle-free monthly travel solutions designed for office commutes, staff transportation, client visits, and corporate operations. Our professional chauffeurs, well-maintained vehicles, and flexible billing plans ensure smooth and cost-effective travel every day. Whether your company needs daily pickup and drop service, dedicated cabs, or long-term corporate mobility solutions, Pune Corporate Cars India Private Limited delivers punctual, safe, and efficient monthly cab services tailored to your business needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



   "services": [
  {
    "name": "Monthly Cab Rental Pune",
    "description": "Monthly Cab Rental Pune offers a convenient and cost-effective transportation solution for businesses and individuals who require consistent travel throughout the month. Our monthly rental plans include dedicated vehicles, trained drivers, and flexible timing options tailored to your schedule. Each vehicle is well-maintained, fully sanitized, and equipped with air-conditioning for daily comfort. Companies benefit from predictable monthly billing, quick replacement vehicles, and priority support. Whether it’s office commute, fieldwork, or daily travel needs, our Monthly Cab Rental service ensures reliability, comfort, and complete peace of mind."
  },
  {
    "name": "Employee Monthly Transport Pune",
    "description": "Employee Monthly Transport Pune is designed for businesses that need seamless, organized, and safe transportation for their workforce. We manage dedicated routes, fixed timings, and efficient pickup–drop schedules to ensure employees reach work on time. Vehicles come with GPS tracking, comfortable seating, and verified drivers for maximum safety. We handle shift-based operations, extended hours, night shifts, and multi-route corporate requirements. With transparent monthly contracts and customized plans, companies can streamline employee mobility while reducing travel stress and improving productivity."
  },
  {
    "name": "Monthly Corporate Cab Hire Pune",
    "description": "Monthly Corporate Cab Hire Pune provides premium, long-term cab solutions for offices, startups, and enterprises. We offer sedans, SUVs, and tempo travellers on a fixed monthly basis with professional drivers and punctual service. This service is ideal for daily corporate travel, executive movement, client visits, and field operations. Vehicles undergo routine inspection and are always kept in perfect working condition. With predictable monthly billing, dedicated support, and a wide range of vehicles, Monthly Corporate Cab Hire ensures consistency, convenience, and a professional travel experience for your team."
  },
  {
    "name": "Monthly Taxi Service Pune",
    "description": "Monthly Taxi Service Pune offers flexible rental arrangements for companies and individuals who require regular, uninterrupted travel. Whether it’s daily office commute, inter-office visits, or field assignments, our taxis are available round the clock. Every trip is safe, comfortable, and driven by experienced chauffeurs. Customers benefit from predictable monthly pricing, reduced cost per ride, and no surge charges. Our fleet includes sedans, hatchbacks, and SUVs that are clean, well-maintained, and perfectly suited for long-term usage. Monthly Taxi Service Pune is your dependable partner for stress-free monthly travel."
  },
  {
    "name": "Pune Office Pickup and Drop Monthly",
    "description": "Pune Office Pickup and Drop Monthly is designed to make daily office commuting smooth, safe, and punctual for employees. We offer customized routes, dedicated cabs, and fixed monthly schedules aligned with shift timings. Vehicles come with air-conditioning, comfortable seats, and GPS monitoring for enhanced security. This service reduces employee fatigue, improves attendance, and ensures reliable workplace mobility. Companies can choose between sedans, SUVs, or tempo travellers depending on their workforce strength. With consistent monthly billing and professional coordination, we ensure hassle-free office transportation every day."
  },
  {
    "name": "Monthly Chauffeur Service Pune",
    "description": "Monthly Chauffeur Service Pune offers premium chauffeur-driven vehicles for executives, CEOs, and business professionals. Customers get dedicated drivers trained in corporate etiquette, route knowledge, and safety protocols. Vehicles include luxury sedans, executive SUVs, and high-comfort premium cars. Perfect for client meetings, airport transfers, daily office commutes, and long-distance corporate travel. The service ensures privacy, punctuality, and complete convenience throughout the month. With fixed monthly plans, companies and individuals enjoy a seamless, reliable, and high-class travel experience."
  },
  {
    "name": "Monthly Sedan Cab Pune",
    "description": "Monthly Sedan Cab Pune offers comfortable and cost-effective sedan vehicles such as Dzire, Etios, and Honda City for daily corporate or personal travel. Perfect for executives, sales teams, office staff, and regular travellers. The sedans ensure smooth rides, superior comfort, and ample luggage space. Customers enjoy fixed monthly pricing, unlimited usage options, and dependable service. Every sedan is maintained regularly, sanitized daily, and handled by trained chauffeurs. Monthly Sedan Cab Pune ensures a professional, consistent, and enjoyable travel experience throughout the month."
  },
  {
    "name": "Monthly SUV Cab Pune",
    "description": "Monthly SUV Cab Pune provides spacious and premium SUV vehicles for businesses and families who require long-term travel comfort. SUVs like Ertiga, Innova, and Crysta are ideal for executive journeys, outstation trips, and high-capacity daily movement. With extra legroom, strong AC, and superior interior comfort, SUVs make every ride pleasant. Customers benefit from dedicated drivers, fixed monthly packages, and priority assistance. Whether it's office commute or corporate tours, Monthly SUV Cab Pune delivers convenience, style, and reliability."
  },
  {
    "name": "Long Term Cab Hire Pune",
    "description": "Long Term Cab Hire Pune is the perfect solution for companies and individuals seeking uninterrupted travel service for months at a time. Our long-term plans include sedans, SUVs, vans, and tempo travellers with dedicated chauffeurs. Vehicles are replaced instantly in case of breakdowns, ensuring zero downtime. This service is ideal for corporate operations, extended projects, field teams, and premium personal use. With predictable monthly billing, flexible contracts, and professional service management, Long Term Cab Hire Pune guarantees consistent comfort and reliability."
  },
  {
    "name": "Monthly Travel Service Pune",
    "description": "Monthly Travel Service Pune offers structured, reliable, and cost-efficient travel services for daily movement across the city. Designed for both businesses and individuals, this service ensures smooth commuting without worrying about per-trip rates. Vehicles come with professional drivers, AC, GPS tracking, and round-the-clock availability. Ideal for office-going employees, executives, and frequent travelers who prefer fixed monthly travel plans. With transparent pricing and timely service, Monthly Travel Service Pune ensures a seamless, stress-free travel experience throughout the month."
  },
  {
    "name": "Pune Monthly Employee Shuttle",
    "description": "Pune Monthly Employee Shuttle provides large-scale transportation for corporate teams, IT parks, and industrial units. We offer fixed-route shuttle services with multiple seating capacities such as 12, 17, and 22-seater vehicles. Each shuttle is equipped with comfortable seating, strong air-conditioning, and real-time tracking. Our operations team manages route planning, shift coordination, and employee attendance mapping. This service reduces travel delays, minimizes costs, and ensures safe and efficient movement for employees every day. Pune Monthly Employee Shuttle is ideal for companies with bulk transport needs."
  },
  {
    "name": "Best Monthly Cab Service Pune",
    "description": "Best Monthly Cab Service Pune offers top-tier, professionally managed monthly taxi solutions for companies and individuals. Known for superior vehicle quality, punctual drivers, and seamless travel experience, this service is ideal for daily office commuting and executive travel. Customers can choose from sedans, SUVs, and luxury vehicles based on their preferences. The service includes unlimited monthly usage options, predictable billing, and 24/7 customer support. Best Monthly Cab Service Pune ensures hassle-free, comfortable, and dependable monthly mobility."
  },
  {
    "name": "Affordable Monthly Cabs Pune",
    "description": "Affordable Monthly Cabs Pune provides budget-friendly monthly travel solutions without compromising on comfort or safety. Ideal for employees, students, families, and small businesses seeking consistent travel at low cost. Vehicles undergo regular maintenance and come with trained chauffeurs for secure and smooth travel. Clients benefit from economical pricing, flexible plans, and zero hidden charges. Whether it’s daily office runs or continuous business travel, Affordable Monthly Cabs Pune ensures great value and reliable service throughout the month."
  },
  {
    "name": "Monthly Fleet Operator Pune",
    "description": "Monthly Fleet Operator Pune delivers fully managed fleet services for businesses that require large-scale, long-term transportation. Companies can hire multiple vehicles including sedans, SUVs, shuttle vans, and tempo travellers on a fixed monthly plan. We handle everything—vehicle management, driver assignment, fuel coordination, and monthly reporting. With optimized routing, punctual service, and skilled chauffeurs, our fleet operations improve employee convenience and business efficiency. Monthly Fleet Operator Pune is perfect for organizations aiming for smooth, centralized, and scalable mobility solutions."
  },
  {
    "name": "Monthly Business Travel Cabs Pune",
    "description": "Monthly Business Travel Cabs Pune offers premium cabs specifically for executives and professionals who require regular travel for meetings, airport drops, site visits, and corporate tours. Vehicles are clean, well-maintained, and driven by disciplined chauffeurs trained in corporate etiquette. The monthly plan ensures consistent availability, predictable billing, and stress-free travel arrangements. With comfortable interiors, strong AC, and safe driving, our business travel cabs enhance productivity and convenience. Monthly Business Travel Cabs Pune is the ideal choice for companies seeking smooth, professional long-term mobility."
  }
],
"tableData": [
  ["Monthly Cab Rental Pune", "Employee Monthly Transport Pune"],
  ["Monthly Corporate Cab Hire Pune", "Monthly Taxi Service Pune"],
  ["Pune Office Pickup and Drop Monthly", "Monthly Chauffeur Service Pune"],
  ["Monthly Sedan Cab Pune", "Monthly SUV Cab Pune"],
  ["Long Term Cab Hire Pune", "Monthly Travel Service Pune"],
  ["Pune Monthly Employee Shuttle", "Best Monthly Cab Service Pune"],
  ["Affordable Monthly Cabs Pune", "Monthly Fleet Operator Pune"],
  ["Monthly Business Travel Cabs Pune", ""]
],


   "whychoose": [
  {
    "WhyChooseheading": "Monthly Cab Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable and cost-effective monthly cab services in Pune, ideal for daily commuting and long-term corporate travel needs."
  },
  {
    "WhyChooseheading": "Affordable Monthly Packages",
    "WhyChoosedescription": "Choose from budget-friendly monthly plans designed to provide consistent and reliable cab services without fluctuating fares."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our cabs are regularly serviced and sanitized to ensure a safe, clean, and comfortable travel experience every day."
  },
  {
    "WhyChooseheading": "Transparent Monthly Billing",
    "WhyChoosedescription": "Enjoy clear and hassle-free monthly billing with no hidden charges, making it easy for both individuals and corporate clients."
  },
  {
    "WhyChooseheading": "Flexible Travel Schedules",
    "WhyChoosedescription": "Customize your daily pickup and drop timings to match office hours or personal routines with complete flexibility."
  },
  {
    "WhyChooseheading": "Professional and Reliable Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure punctual, safe, and stress-free travel throughout the month."
  },
  {
    "WhyChooseheading": "24/7 Assistance and Support",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to handle schedule changes, urgent requests, or travel coordination."
  },
  {
    "WhyChooseheading": "Easy Monthly Booking Process",
    "WhyChoosedescription": "Book your monthly cab service quickly through our simple online process or by phone, with quick confirmations and dependable service."
  }
]























  }

  const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer monthly cab services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides flexible and affordable monthly cab services for office commute, business travel, and regular transportation needs.',
  },
  {
    question: 'How can I book a monthly cab service in Pune?',
    answer: 'You can book effortlessly through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What vehicles are available for monthly cab services in Pune?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit different monthly travel requirements.',
  },
  {
    question: 'Are the drivers trained and experienced for long-term monthly service?',
    answer: 'Yes, our drivers are professional, punctual, and well-trained to provide consistent service throughout the month.',
  },
  {
    question: 'Can Pune Corporate Cars India Private Limited customize monthly cab packages?',
    answer: 'Absolutely. We offer customizable monthly packages based on distance, duration, and vehicle type.',
  },
  {
    question: 'Is the monthly cab service available 24×7 in Pune?',
    answer: 'Yes, we provide 24×7 availability for monthly cab services to match your schedule.',
  },
  {
    question: 'What safety and hygiene protocols are followed in monthly cab services?',
    answer: 'All vehicles are sanitized regularly and drivers adhere to strict safety and hygiene standards.',
  },
  {
    question: 'What payment methods are accepted for monthly cab bookings?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and corporate billing options.',
  },
  {
    question: 'Is customer support available throughout the monthly service period?',
    answer: 'Yes, our customer support team is available 24×7 to assist you during your monthly cab service.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kiran More',
    feedback: 'The monthly cab service from Pune Corporate Cars India Private Limited is reliable and perfectly suited for my daily office travel. Highly professional drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riya Chavan',
    feedback: 'Great experience with their monthly cab plan. Clean cars, punctual service, and very cooperative staff.',
    rating: 5,
  },
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Cab Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/monthly-cabs-pune.jpg", // replace with actual image URL
  "description": "Reliable monthly cab services in Pune for employees and corporate clients. Pune Corporate Cars India Private Limited offers monthly rentals, chauffeur-driven sedans and SUVs, office pickup and drop, and long-term business travel cabs for seamless commuting.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4800", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000", // starting monthly price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/monthly-cab-services-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Monthly Cab Services in Pune | Employee & Corporate Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable monthly cab services in Pune for corporate employees and business travel. Hire monthly sedans, SUVs, and chauffeur-driven cabs with Pune Corporate Cars India Private Limited for office pickup, drop, and long-term commuting."
  />

  <meta
    name="keywords"
    content="Monthly Cab Rental Pune, Employee Monthly Transport Pune, Monthly Corporate Cab Hire Pune, Monthly Taxi Service Pune, Pune Office Pickup and Drop Monthly, Monthly Chauffeur Service Pune, Monthly Sedan Cab Pune, Monthly SUV Cab Pune, Long Term Cab Hire Pune, Monthly Travel Service Pune, Pune Monthly Employee Shuttle, Best Monthly Cab Service Pune, Affordable Monthly Cabs Pune, Monthly Fleet Operator Pune, Monthly Business Travel Cabs Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/120.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycabserviceinpune;